import React from 'react';
//* MUI
import { Box, Switch } from '@mui/material';
import { styled } from '@mui/material/styles';
import { SwitchProps } from '@mui/material/Switch';
//* Styles
import './CustomSwitch.scss';

const IOSSwitch = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        background:
          theme.palette.mode === 'dark'
            ? '#2ECA45'
            : 'linear-gradient(90deg, #E3AB00 0%, #FFD000 50%, #FFE539 100%)',
        opacity: 1,
        border: 0
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5
      }
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#33cf4d',
      border: '6px solid #fff'
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color: theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[600]
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: theme.palette.mode === 'light' ? 0.7 : 0.3
    }
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 22,
    height: 22
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.mode === 'light' ? '#ABADCF80' : '#39393D',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500
    })
  }
}));

interface IProps {
  label?: string;
  checked: boolean;
  handleChecked?: () => void;
}

const CustomSwitch = ({ label, checked, handleChecked }: IProps) => {
  return (
    <Box className="custom-switch" onClick={handleChecked}>
      <IOSSwitch checked={checked} />
      {label && <Box className="custom-switch__title">{label}</Box>}
    </Box>
  );
};

export default CustomSwitch;
